import * as React from 'react'

export default function Loader() {
  return <div>loader placeholder</div>
}
